import { render, staticRenderFns } from "./noticeChangeLogModal.vue?vue&type=template&id=e3b22720&scoped=true&"
import script from "./noticeChangeLogModal.vue?vue&type=script&lang=ts&"
export * from "./noticeChangeLogModal.vue?vue&type=script&lang=ts&"
import style0 from "./noticeChangeLogModal.vue?vue&type=style&index=0&id=e3b22720&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3b22720",
  null
  
)

export default component.exports